import { CompanySizeAttributes } from 'signup-constants/signupData/CompanySizeAttributes';
export const getCompanySizeFormatted = companySizeAnswer => {
  const companySize = CompanySizeAttributes[companySizeAnswer];
  return companySize || {
    companySizeNumber: null,
    companySizeLabel: null
  };
};